"use client";
import { useEffect } from "react";
import { useAuthStore, useShopStore } from "stores";
import dayjs from "utils/dayjs";
import initTokenDebug from "utils/tokenDebug";

export default function AppInitializer({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated } = useAuthStore();
  const { shopStaff, shop, loadShopStaff, setSSR } = useShopStore();

  // Initialize token debug tools and set client-side rendering flag
  useEffect(() => {
    setSSR(false);
    initTokenDebug();
  }, [setSSR]);

  // Load shop staff when user is authenticated
  useEffect(() => {
    const initializeShopData = async () => {
      if (user?.id && isAuthenticated) {

        try {
          const staff = await loadShopStaff(user.id);

        } catch (error) {
          console.error("❌ [AppInitializer] Error loading shop staff:", error);
        }
      }
    };

    initializeShopData();
  }, [user?.id, isAuthenticated]);

  // Note: Bookings are now loaded only on specific pages (Home and Manage)
  // to avoid unnecessary API calls on other pages

  return <>{children}</>;
}